// ==============================
//  DEV
// ==============================
const developmentConfig = {
  // API
  apiUrl: 'https://crs.medicalsoftware.pl'
}


// ==============================
//  PRO
// ==============================
const productionConfig = {
  // API
  apiUrl: 'https://crs.medicalsoftware.pl'
}


// ==============================
//  COMMON
// ==============================
const appName = ''
const commonConfig = {
  // DANE OGOLNE
  appName: appName,
  siteName: appName,
  logoPath: '/public/img/logo.png',
  meta: {
    title: appName,
    titleTemplate: '%s | ' + appName,
    description: '',
    keywords: ''
  },
  og: {
    titleTemplate: '%s',
    type: 'website'
  },
  langs: ['pl'],
  defaultLang: 'pl'
}


export const appConfig = Object.assign(
  commonConfig,
  (process.env.NODE_ENV == 'production') ? productionConfig : developmentConfig
)
